<template>
  <div id="app">
    <AGWAudio :file="music.file" :loop="music.loop" :autoplay="music.autoplay"/>
    <AGWHero overlay :background="backgrounds" ref="hero" parallax target="#intro"/>

    <div class="agw-content bg-white" :style="{ 'margin-top' : `${$root.hero.height}px` }">
      <AGWIntro id="intro"/>

      <div class="pad-y-60">
        <AGWPawiwahan id="pawiwahan"/>
        <AGWMepandes id="mepandes" class="mar-top-60" :mepandes="mepandes"/>
      </div>

      <AGWCounter
        id="counter"
        class="pad-y-60"
        :background="background"
        date="2019-12-30 11:00:00"
      />
      <AGWGallery id="gallery" class="pad-y-60"/>
      <AGWMap
        :height="450"
        url="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3944.0746544691688!2d115.20679951478412!3d-8.684450893760314!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zOMKwNDEnMDQuMCJTIDExNcKwMTInMzIuNCJF!5e0!3m2!1sen!2sid!4v1576202847064!5m2!1sen!2sid"
        directionUrl="https://www.google.com/maps/dir//-8.6844509,115.2089882/@-8.6844456,115.2067995,17z/data=!4m2!4m1!3e0"
        :location="location"
        :date="date"
        :time="time"
        id="map"
      />
    </div>

    <div class="agw-content" style="background: transparent">
      <attendance id="attendance" class="pad-y-60"></attendance>
    </div>

    <div :style="{ 'height' : `${$root.dividerHeight}px` }"></div>

    <section class="footer bg-white pad-y-20" ref="footer">
      <div class="font-weight-lighter">
        &copy; 2019. Made by <a href="https://ceremonyku.com">ceremonyku</a>.
      </div>
    </section>

    <transition name="slide-fade">
      <guest-box :floating="true" v-if="$root.scroll.Y > $root.hero.height"/>
    </transition>

    <div class="snackbar" v-if="sw.updateExists">
      New version available!
      <button @click="refreshApp" class="btn">REFRESH</button>
    </div>
  </div>
</template>

<script>
import ImageHero1 from "@/assets/images/gallery/IMG_6102.jpg";
import ImageHero2 from "@/assets/images/gallery/IMG_6749.jpg";
import ImageHero3 from "@/assets/images/gallery/IMG_6799.jpg";
import ImageHero4 from "@/assets/images/gallery/IMG_6333.jpg";
import ImageHero5 from "@/assets/images/gallery/IMG_6282.jpg";

import Audio from "@/assets/audio/you-are-the-one.mp3";

import AGWHero from "@/components/Hero";
import AGWIntro from "@/components/Intro";
import AGWPawiwahan from "@/components/Pawiwahan";
import AGWMepandes from "@/components/Mepandes";
import AGWCounter from "@/components/Counter";
import AGWGallery from "@/components/Gallery";
import AGWMap from "@/components/Maps";
import AGWAudio from "@/components/Audio";
import GuestBox from "@/components/GuestBox";
import Attendance from "@/components/Attendance";

import { setInterval } from "timers";

export default {
  name: "app",
  components: {
    AGWHero,
    AGWIntro,
    AGWPawiwahan,
    AGWMepandes,
    AGWCounter,
    AGWGallery,
    AGWMap,
    AGWAudio,
    GuestBox,
    Attendance
  },
  data() {
    return {
      // background: ImageHeroOne,
      backgrounds: [ImageHero1, ImageHero2, ImageHero3, ImageHero4, ImageHero5],
      bgActive: 0,
      dividerHeight: 0,
      location: "Jalan Pulau Saelus Gg IV A, No 4, Kel Pedungan, Denpasar Selatan - Denpasar",
      date: "Senin, 30 Desember 2019",
      time: {
        start: "11.00",
        end: "Selesai"
      },
      mepandes: [
        "I Putu Pande Putra Wanda, S.Kom",
        'Ni Kadek Ayu Winda Lestari, SE',
        'Ni Komang Aniek Sugiantini',
        'Pande Putu Indirayani',
        'Ni Ketut Muliani'
      ],
      music: {
        file: Audio,
        autoplay: true,
        loop: true
      },
      sw: {
        refreshing: false,
        registration: null,
        updateExists: false
      }
    };
  },
  computed: {
    background() {
      return this.backgrounds[this.bgActive];
    }
  },
  mounted() {
    this.dividerHeight = `calc(100vh - ${this.$refs.footer.offsetHeight}px)`;
    setInterval(() => {
      let active = this.bgActive + 1;
      if (active >= this.backgrounds.length) {
        active = 0;
      }

      this.bgActive = active;
    }, 5000);
  },
  created() {
    document.addEventListener("swUpdated", this.showRefreshUI, { once: true });
    if(navigator.serviceWorker) {
      navigator.serviceWorker.addEventListener("controllerchange", () => {
      if (this.sw.refreshing) return;
      this.sw.refreshing = true;
      window.location.reload();
    });
    }
  },
  methods: {
    showRefreshUI(e) {
      this.sw.registration = e.detail;
      this.sw.updateExists = true;
    },
    refreshApp() {
      this.sw.updateExists = false;
      if (!this.sw.registration || !this.sw.registration.waiting) {
        return;
      }
      this.sw.registration.waiting.postMessage("skipWaiting");
    }
  }
};
</script>
